import { render, staticRenderFns } from "./BasicChart.vue?vue&type=template&id=bd57e256&"
import script from "./BasicChart.vue?vue&type=script&lang=js&"
export * from "./BasicChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports